export default __webpack_public_path__ + "static/media/lifesatisfaction5Img3.013e459b.png";